var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    `w-100 d-flex justify-content-${_vm.justify} mc-readonly`,
    { 'flex-column': _vm.orientation === 'vertical' },
  ]},_vm._l((_vm.items),function(item,idx){return _c('div',{key:idx,staticClass:"mc-readonly__item"},[_c('div',{staticClass:"__label"},[_vm._v(_vm._s(item.label))]),_c('div',{class:`__value${item.bold ? '-bold' : ''}`},[_vm._v(_vm._s(item.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }